import { useTranslation } from '@splitfiesta/i18n';

export function LinkFooter({ payer }: { payer: string }) {
  const { t } = useTranslation('claimLink');
  return (
    <p className="pt-2 text-center text-sm text-gray-600 dark:text-gray-400">
      {t('footer', { payer })}
    </p>
  );
}
